(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var cards = root.querySelectorAll('[data-reveal]');
    if (!cards.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      cards.forEach(function (card) {
        card.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry, index) {
          if (entry.isIntersecting) {
            var card = entry.target;
            var delay = (index % 6) * 60;
            setTimeout(function () {
              card.classList.add('is-visible');
            }, delay);
            observer.unobserve(card);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }

function initReviews(root) {
    var PAGE_SIZE = 4;
    var bars = root.querySelectorAll('[data-star-filter]');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-rating]'));
    var clearBtn = root.querySelector('[data-clear-filter]');
    var emptyState = root.querySelector('[data-empty-state]');
    var showMoreBtn = root.querySelector('[data-show-more]');
    var activeFilter = null;
    var visibleCount = PAGE_SIZE;

    if (!rows.length) return;

    function apply() {
      var matched = 0;
      var shown = 0;

      rows.forEach(function (row) {
        var matchesFilter = !activeFilter || row.getAttribute('data-rating') === activeFilter;
        if (matchesFilter) {
          matched += 1;
          var withinLimit = matched <= visibleCount;
          row.classList.toggle('is-filtered-out', !withinLimit);
          if (withinLimit) shown += 1;
        } else {
          row.classList.add('is-filtered-out');
        }
      });

      bars.forEach(function (bar) {
        var isActive = bar.getAttribute('data-star-filter') === activeFilter;
        bar.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (clearBtn) clearBtn.hidden = !activeFilter;
      if (emptyState) emptyState.hidden = matched !== 0;
      if (showMoreBtn) showMoreBtn.hidden = shown >= matched;
    }

    bars.forEach(function (bar) {
      bar.addEventListener('click', function () {
        var value = bar.getAttribute('data-star-filter');
        activeFilter = activeFilter === value ? null : value;
        visibleCount = PAGE_SIZE;
        apply();
      });
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        activeFilter = null;
        visibleCount = PAGE_SIZE;
        apply();
      });
    }

    if (showMoreBtn) {
      showMoreBtn.addEventListener('click', function () {
        visibleCount += PAGE_SIZE;
        apply();
      });
    }

    apply();
  }

  function init(section) {
    initReveal(section);
    initReviews(section);
  }

  document.querySelectorAll('.reviews-split-section').forEach(init);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.reviews-split-section');
    if (section) init(section);
  });
})();